<template>
  <div @click="checked = !checked" class="custom-control custom-radio">
    <input
      id="radio"
      v-model="checked"
      name="paymentMethod"
      type="checkbox"
      class="custom-control-input"
    />
    <label class="custom-control-label" for="radio" style="color: white;"
      >Focus on female entrepreneurs</label
    >
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "FemaleFocusRadio",
  data: function() {
    return {
      checked: false
    };
  },
  computed: {
    ...mapGetters(["selectedDropdownFemaleFocus"])
  },
  methods: {
    ...mapMutations({
      setFemaleFocus: "setFemaleFocusParam",
      setDropdownFemaleFocus: "setDropdownFemaleFocus"
    }),
    toggleFemaleFocus: function() {
      this.setFemaleFocus(!this.femaleFocusSelected);
    }
  },
  watch: {
    checked: function(value) {
      this.setFemaleFocus(value);
      this.setDropdownFemaleFocus(value);
    }
  },
  mounted() {
    this.checked = this.selectedDropdownFemaleFocus;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/FemaleFocusRadio.vue